document.addEventListener('DOMContentLoaded', function () {
    const paragraphts = document.querySelectorAll('p.bildverweis');
    for (let paragraph of paragraphts) {
        let nextSibling = paragraph.nextSibling;
        if (nextSibling == null || !nextSibling.classList.contains('bildverweis')) {
            paragraph.classList.add('mb-7');
        }
    }
});
